export const AgeConfig = {
  minAge: 18,
  maxAge: 90,
  ageOptions: Array.from({ length: 73 }, (_, i) => i + 18),
}
